// extracted by mini-css-extract-plugin
export default {"active":"NavigationPage_active__nQ12s","navi_box":"NavigationPage_navi_box__bT3gV","subject":"NavigationPage_subject__wtMFD"};